// Apple Music library reads for the music card (M4). Hits the HA-gated
// /music-api/apple-lib endpoint, which uses the server-stored Music User Token
// (the MUT-bridge). Unlike the Spotify hooks (which use the Spotify user token),
// this authenticates with the HA OAuth token — same gate as the builder's
// Function calls — so it takes `hass`, not the Spotify `getToken`.

async function haToken(hass) {
  const auth = hass?.auth;
  if (!auth) return '';
  try { if (auth.expired) await auth.refreshAccessToken(); } catch { /* use current */ }
  return auth.accessToken || '';
}

// Fetch from apple-lib. `query` is '' for the playlist list or
// `?playlist=<id>` for one playlist's tracks. Throws Error('apple_not_connected')
// when no MUT is stored, so callers can show the connect hint.
export async function appleLib(hass, query = '') {
  const token = await haToken(hass);
  const res = await fetch(`/music-api/apple-lib${query}`, {
    headers: { authorization: `Bearer ${token}` },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || `apple-lib ${res.status}`);
  return data;
}

// POST to a music-api endpoint with the HA token (used by the sync to call
// apple-sync). Throws an Error carrying .status so the caller can stop on 401.
export async function applePost(hass, path, body) {
  const token = await haToken(hass);
  const res = await fetch(`/music-api/${path}`, {
    method: 'POST',
    headers: { 'content-type': 'application/json', authorization: `Bearer ${token}` },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const e = new Error(data.error || `${path} ${res.status}`);
    e.status = res.status;
    throw e;
  }
  return data;
}
